import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TypographyComponent } from '../typography/typography.component';

@Component({
  selector: 'hyperkit-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  standalone: true,
  imports: [CommonModule, TypographyComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioButtonComponent {
  @Input() public name: string = '';
  @Input() public disabled: boolean = false;
  @Input() public selected: boolean = false;
  @Input() public text: string = '';

  public onChange(event: Event) {
    // Handle change event
  }
}
